module.exports = __webpack_public_path__ + "img/root0.36525bbc.png";